import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import HeadBlock from '../../../FileUpload/HeadBlock';
import HalyconBar from './ProgressBarHelycon';
const SendRequestModal = ({ _modalStatus, _successRes, _handleModalStatus, heading }) => {
    let history = useHistory();
    const [realTime, setRealTime] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [uploadFileStatus, setUploadFileStatus] = useState(true);
    const filesize = useMemo(() => (1009))
    const currentTime = useMemo(() => (Date.now()))
    return (
        <Modal isOpen={_modalStatus} toggle={_handleModalStatus} className="file-version-modal">
            <ModalBody>
                <HeadBlock showFolder={true} isSaveVersion={true} />
                <div className="inner-blc">
                    <HalyconBar isHalycon={true} action={realTime} isPaused={isPaused} currentTime={currentTime} filesize={filesize} uploadFileStatus={uploadFileStatus} isSaveVersion={true} heading={heading} />
                </div>
                {/* <div key={`${_file.path}_${index}`} className="inner-blc">
                    <Bar action={realTime} selectedFiles={selectedFiles} isPaused={isPaused} currentTime={currentTime} filesize={filesize} setIsFileSizeLarge={setIsFileSizeLarge} uploadFileStatus={uploadFileStatus} uploadFileStatusMessage={uploadFileStatusMessage} />
                </div> */}
            </ModalBody>
        </Modal>
    );
}

export default SendRequestModal;